var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full sm:w-1/1 md:w-1/1 mb-base"},[_c('vx-card',{attrs:{"title":"Novidades do Sistema"}},[_c('vx-timeline',{attrs:{"data":_vm.timelineData}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }